app.factory("$filter_select",function(_$filter){
    
    
    
    return {
        
      prefilter:function(scope){
         
        if ( typeof scope.selectIsAll==='undefined')
        scope.selectIsAll=false;
         
        if (scope.selectIsAll){//if select was previous on ALL
        
            scope.selectIsAll=false;
            
            var arr=scope.model.value.filter(function(val){ return val>0 });
            
            if (arr.length===scope.model.value)
            return [];//remove all
            else
                return arr;
        }
        
        if (!scope.selectIsAll && scope.multiple && scope.model.value.indexOf(0)!=-1){//element 0 so ALL
        
            scope.selectIsAll=true;      
            return scope.options.map(function(val){ return val.value; });
            
        }
        
        return scope.model.value;
          
      },
      getTemplate:function(){
          
          
          return _$filter.getPath()+"/adapters/select.html";
      }
        
    };
    
});

